import { Document } from '../../jurisdiction/jurisdiction.domain';
import { TechnicalData } from 'src/app/+grid-application-shared/entities/technicalData';
import { CommissioningOfEnergyProducer } from './commissioning-of-energy-producer';
import { ProvisioningOfCurrentTransformers } from './provisioning-of-current-transformers';
import { RegepTechnicalSpecificationsSectionsState } from './sections-state/regepTechnicalSpecificationsSectionsState';
import { RegepProvisioningType } from './enums/regepProvisioningType';
import { ShippingAddress } from './shipping-address';
import { GridApplicationDocumentTypes } from 'src/app/+grid-application-shared/entities/enums/grid-application-document-types.enum';

export class RegistrationOfEnergyProducerTechnicalData extends TechnicalData {
  constructor() {
    super();
  }

  preferred_provisioning_date?: Date;
  confirmed_provisioning_date?: Date;
  ripple_control_receiver_preferred_pickup_date?: Date;
  ripple_control_receiver_confirmed_pickup_date?: Date;
  feed_in_controllability_contract: Document = new Document(GridApplicationDocumentTypes.FeedInControllabilityContract);
  provisioning_type: RegepProvisioningType;

  commissioning_of_energy_producer: CommissioningOfEnergyProducer = new CommissioningOfEnergyProducer();
  provisioning_of_current_transformers: ProvisioningOfCurrentTransformers = new ProvisioningOfCurrentTransformers();
  shipping_address: ShippingAddress = new ShippingAddress(this.application_id);
  technical_specifications_sections_state: RegepTechnicalSpecificationsSectionsState;
}
